
import React from 'react';
import { Link } from 'react-router-dom';

const NavbarLogo: React.FC = () => {
  return (
    <Link to="/" className="flex items-center space-x-2 mr-6">
      <div className="relative w-8 h-8 bg-primary rounded-full flex items-center justify-center animate-pulse-slow">
        <span className="text-white font-bold text-lg">🌀</span>
      </div>
      <div className="flex items-baseline gap-0.5">
        <span className="text-[0.65rem] font-bold text-primary">
          SCIO
        </span>
        <span className="text-lg font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Curio
        </span>
      </div>
    </Link>
  );
};

export default NavbarLogo;
